import { mapRasseTkv } from '@ps20-frontend/migrations';
import { IAnimalValueLabelElement, ValueLabelElement } from '@ps20-frontend/frontend-models';
import { TkvAngabenElement } from '../reducer/tkvAngaben.reducer';
import { TkvAngabenV2Item } from '../reducer/tkvAngabenV2.reducer';
import { StatePreV22, StateV22 } from './22_migrate_rasse_pyrenaeen.interface';

export const migrateRassePyrenaeen = (previousState: StatePreV22, newVersion: number): StateV22 => {
  return {
    ...previousState,
    version: newVersion,
    tkvAngaben: {
      ...previousState.tkvAngaben,
      angabenListe: mapTkvAngaben(previousState.tkvAngaben.angabenListe),
    },
    tkvAngabenV2: previousState.tkvAngabenV2
      ? {
          ...previousState.tkvAngabenV2,
          angabenItems: mapTkvAngabenV2Items(previousState.tkvAngabenV2.angabenItems),
        }
      : previousState.tkvAngabenV2,
  };
};

function mapTkvAngaben(tkvAngaben: TkvAngabenElement[]): TkvAngabenElement[] {
  return tkvAngaben?.map(angabe => {
    return { ...angabe, rasse: { ...angabe.rasse, value: mapRasseTkv(angabe.rasse.value) } };
  });
}

const remapBreedCode = (breed: ValueLabelElement): IAnimalValueLabelElement => {
  if (!breed) {
    return breed;
  }
  const animalBreed = breed as IAnimalValueLabelElement;
  return {
    ...animalBreed,
    value: mapRasseTkv(animalBreed.value),
    motherBreed: animalBreed.motherBreed
      ? { ...animalBreed.motherBreed, value: mapRasseTkv(animalBreed.motherBreed.value) }
      : animalBreed.motherBreed,
  };
};

function mapTkvAngabenV2Items(items: TkvAngabenV2Item[]): TkvAngabenV2Item[] {
  return items?.map(item => {
    return {
      ...item,
      breed: remapBreedCode(item.breed),
    };
  });
}
